module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Dynamic DNS Manager":"Dynamic DNS Manager","Username":"Username","Password":"Password","One Time Password":"One Time Password","Cancel":"Cancel","Continue":"Continue","Loading":"Loading","None":"None","N/A":"N/A","Yes":"Yes","No":"No","Invalid API response.":"Invalid API response.","YYYY-MM-DD":"YYYY-MM-DD","YYYY-MM-DD HH:mm:ss":"YYYY-MM-DD HH:mm:ss"}}')
  delete Component.options._Ctor
}
